var customTags = {
	currentYear: { label: "Current Year", id: "currentYear['y']", value: "2022" },
	currentMonth: {
		label: "Current Month",
		id: "currentMonth['m']",
		value: "07",
	},
	currentDay: { label: "Current Day", id: "currentDay['d']", value: "01" },
	currentDate: { label: "Current Date", id: "currentDate['d-m-Y']", value: "" },
	currentTime: {
		label: "Current Time",
		id: "currentTime['h:i:sa']",
		value: "",
	},
	postPublishDate: {
		label: "Post Publish Date",
		id: "postPublishDate['d-m-Y']",
		value: "",
	},
	postModifiedDate: {
		label: "Post Modified Date",
		id: "postModifiedDate['d-m-Y']",
		value: "",
	},
	termId: { label: "Term Id", id: "termId", value: "" },
	termTitle: { label: "Term Title", id: "termTitle", value: "" },
	termDescription: {
		label: "Term Description",
		id: "termDescription",
		value: "",
	},
	termPostCount: { label: "Term Post Count", id: "termPostCount", value: "" },
	postTagTitle: { label: "Post Tag Title", id: "postTagTitle", value: "" },
	postTagsTitle: {
		label: "Post Tags Title",
		id: "postTagsTitle['3']",
		value: "",
	},
	postCategoryTitle: {
		label: "Post Category Title",
		id: "postCategoryTitle",
		value: "",
	},
	postCategoriesTitle: {
		label: "Post Categories Title",
		id: "postCategoriesTitle['3']",
		value: "",
	},
	postTermTitle: {
		label: "Post Term Title",
		id: "postTermTitle['taxonomy']",
		value: "",
	},
	postTermsTitle: {
		label: "Post Terms Title",
		id: "postTermsTitle['taxonomy,3']",
		value: "",
	},
	postSlug: { label: "Post Slug", id: "postSlug", value: "" },
	postId: { label: "Post ID", id: "postID", value: "" },
	postStatus: { label: "Post Status", id: "postStatus", value: "" },
	authorId: { label: "Author Id", id: "authorId", value: "" },
	authorName: { label: "Author Name", id: "authorName", value: "" },
	authorFirstName: {
		label: "Author FirstName",
		id: "authorFirstName",
		value: "",
	},
	authorLastName: {
		label: "Author Last Name",
		id: "authorLastName",
		value: "",
	},
	authorDescription: {
		label: "Author Description",
		id: "authorDescription",
		value: "",
	},
	excerpt: { label: "Post Excerpt", id: "excerpt", value: "" },
	rankmathTitle: { label: "Rankmath Title", id: "rankmathTitle", value: "" },
	// rankmathPermalink: {
	// 	label: "Rankmath Permalink",
	// 	id: "rankmathPermalink",
	// 	value: "",
	// },
	rankmathDescription: {
		label: "Rankmath Description",
		id: "rankmathDescription",
		value: "",
	},
	rankmathFocusKeyword: {
		label: "Rankmath Focus Keyword",
		id: "rankmathFocusKeyword",
		value: "",
	},
	// rankmathFocusKeywords: {
	// 	label: "Rankmath Focus Keywords",
	// 	id: "rankmathFocusKeywords[', ']",
	// 	value: "",
	// },
	rankmathOrgname: {
		label: "Rankmath Org name",
		id: "rankmathOrgname",
		value: "",
	},
	rankmathOrgurl: {
		label: "Rankmath Org URL",
		id: "rankmathOrgurl",
		value: "",
	},
	rankmathOrglogo: {
		label: "Rankmath Org logo",
		id: "rankmathOrglogo",
		value: "",
	},
	siteTitle: { label: "Site Title", id: "siteTitle", value: "" },
	siteDescription: {
		label: "Site Description",
		id: "siteDescription",
		value: "",
	},
	// siteTagline: { label: "Site Tagline", id: "siteTagline", value: "" },
	postMeta: { label: "Post Meta", id: "postMeta['metaKey']", value: "" },
	separator: { label: "Separator", id: "separator['-']", value: "" },
	searchTerms: { label: "Search Terms", id: "searchTerms", value: "" },
	counter: { label: "Counter", id: "counter", value: "" },
};

export default customTags;
